import { Box, Chip } from '@mui/material';
import { Palette } from '@/themes/themeOverrides/Palette';
import { useTranslate } from 'react-admin';

const chipSx = {
    backgroundColor: Palette.white,
    height: 'auto',
    paddingBlock: '8px',
    borderRadius: '12px',
    '& .MuiChip-label': {
        fontSize: '14px',
        whiteSpace: 'normal',
        lineHeight: '20px',
    },
};

const valueChipSx = {
    backgroundColor: Palette.gray.gray200,
    color: Palette.gray.gray700,
    fontWeight: 400,
    height: 'auto',
    paddingBlock: '4px',
    borderRadius: '12px',
    '& .MuiChip-label': {
        fontSize: '14px',
        whiteSpace: 'normal',
        lineHeight: '20px',
    },
};

const CriteriaValueChip = ({ formattedValue, label, categories = [], isMainChip = false }) => {
    const translate = useTranslate();
    if (formattedValue.type === 'categories') {
        return formattedValue.categoryIds.map(categoryId => {
            const category = categories.find(cat => cat.id === categoryId);
            return (
                <Chip
                    key={`category-${categoryId}`}
                    label={category?.name || `${translate('resources.campaign.labels.category')} ${categoryId}`}
                    sx={{
                        ...chipSx,
                        backgroundColor: category?.colorDark || Palette.gray.gray200,
                        paddingBlock: '4px',
                    }}
                />
            );
        });
    } else {
        const chipStyle = isMainChip ? chipSx : valueChipSx;
        return (
            <Chip
                label={
                    label ? (
                        <Box sx={{ display: 'inline-flex', gap: '2px', flexWrap: 'wrap' }}>
                            {label}:<Box sx={{ fontWeight: 700, fontSize: isMainChip ? '14px' : 'inherit' }}>{formattedValue.value}</Box>
                        </Box>
                    ) : (
                        formattedValue.value
                    )
                }
                sx={chipStyle}
            />
        );
    }
};

export default CriteriaValueChip;
